/**
 * Learnings — KB entries extracted during a run, grouped by type.
 *
 * CSS: styles/components/learnings.css
 */

import { esc } from '../../shared/rendering.js'
import type { LearningCardProps } from '../../types/components.js'

/** Render a group of learnings by type. */
export function renderLearnings(items: ReadonlyArray<LearningCardProps>): string {
  if (items.length === 0) {
    return ''
  }

  // Group by type
  const groups = new Map<string, LearningCardProps[]>()
  for (const item of items) {
    const existing = groups.get(item.type) ?? []
    existing.push(item)
    groups.set(item.type, existing)
  }

  return [...groups.entries()]
    .map(([type, entries]) => {
      const typeClass =
        type === 'learning'
          ? 'learned'
          : type === 'pattern'
            ? 'pattern'
            : type === 'convention'
              ? 'convention'
              : 'learned'
      const header = `<div class="lg ${typeClass}">${esc(type)}</div>`
      const cards = entries
        .map(
          (e) =>
            `<div class="li ${typeClass}">
          <div class="li-t">${esc(e.title)}</div>
          ${e.body ? `<div class="li-b">${esc(e.body)}</div>` : ''}
        </div>`,
        )
        .join('')
      return header + cards
    })
    .join('')
}
